/**
 * AcceptedPaymentsRow — payment method visibility strip.
 * Displays Wallid Pay-by-Bank (Open Banking) as the accepted payment method.
 * Historically included card-scheme logos; now bank-only.
 */
import { Landmark } from "lucide-react";

const WallidBadge = () => (
  <div
    aria-label="Powered by Wallid Pay-by-Bank"
    title="Powered by Wallid Pay-by-Bank"
    className="h-6 px-2 inline-flex items-center border border-[#E2E8F0] bg-white rounded-sm"
  >
    <span className="font-mono text-[10px] uppercase tracking-wider text-[#1B3A5C] font-semibold">
      Wallid · Pay-by-Bank
    </span>
  </div>
);

const BankTransferBadge = () => (
  <div
    aria-label="UK bank transfer accepted"
    title="UK bank transfer (Faster Payments)"
    className="h-6 px-2 inline-flex items-center gap-1 border border-[#E2E8F0] bg-white rounded-sm"
  >
    <Landmark className="w-3 h-3 text-[#1B3A5C]" strokeWidth={2} />
    <span className="font-mono text-[10px] uppercase tracking-wider text-[#1B3A5C] font-semibold">
      Bank transfer
    </span>
  </div>
);

export const AcceptedPaymentsRow = ({
  showBankTransfer = true,
  className = "",
  label = "Accepted payment methods",
  compact = false,
}) => (
  <div
    data-testid="accepted-payments"
    className={`flex items-center flex-wrap gap-2 ${className}`}
  >
    {!compact && (
      <span className="sb-mono-label text-[10px] mr-1">{label}</span>
    )}
    {showBankTransfer && <BankTransferBadge />}
    <WallidBadge />
  </div>
);

export default AcceptedPaymentsRow;
